import { Loader2 } from "lucide-react";
import { Dialog } from "./Dialog";
import { config } from "@/config";
import { cn } from "@/lib/utils";
import { useState, useRef, ReactNode } from "react";

type LinkButtonProps = {
    href: string;
    trigger?: ReactNode;
};
export function LinkButton({ href, trigger }: LinkButtonProps) {
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupLoading, setPopupLoading] = useState(false);
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const useDialog = false; //config.inStandalone;

    return <>
        <div
            className="contents"
            onClick={() => {
                if (useDialog) {
                    setPopupLoading(true);
                    setPopupOpen(true);
                } else {
                    open(href, "_blank");
                }
            }}
        >
            {trigger}
        </div>
        {
            useDialog && <Dialog
                open={popupOpen}
                onOpenChange={(open) => {
                    setPopupOpen(open);
                    if (open) setPopupLoading(true);
                }}
            >
                {popupLoading && <Loader2 className="animate-spin" />}
                <iframe
                    onLoad={() => {
                        setPopupLoading(false);
                    }}
                    ref={iframeRef}
                    className={cn(
                        "h-[95dvh] w-full",
                        popupLoading && "hidden",
                    )}
                    src={href}
                />
            </Dialog>
        }
    </>;
}